import { React, Component, Container, Icon, _ } from 'utils';
import { Campaigns, ResumeStore, MoveStore, Creators } from 'model';
import Campaign from './campaign';
import './campaignselector.less';

class CampaignSelector extends Component {

	static getStores() {
		return [Campaigns, ResumeStore, MoveStore];
	}

	static calculateState(state, props) {
		var cstate = Campaigns.getState();

		return {
			onSelect: props.onSelect,
			campaigns: cstate.campaigns,
			selected: ResumeStore.getSelectedCount(),
			show: props.show,
			visible: MoveStore.getState().folder == null,
			active: cstate.active
		}
	}
	
	render() {
		var { selected, visible, show, active } = this.state;

		var count = ' (' + selected + ') ';
		if(show || selected == 0) {
			count = '';
		}

		const className = this.props.className ? this.props.className : "btn btn-default";

		return (
			<button
				disabled={selected <= 0}
				className={className}
				onClick={Creators.showFolders}
			>
				<i className="fa fa-arrow-right"></i> <i className="fa fa-folder-open-o"></i>{' '}
				{_('Spremi')}
                <span>{ count }</span>
			</button>
		);
	}
}

const CSContainer = Container.create(CampaignSelector, {withProps: true });
export default CSContainer;


// WEBPACK FOOTER //
// ./src/modules/app/resumes/campaignselector.js